import { FilterComponent } from './components/filter.component';
new FilterComponent();

import { FormOptionalBlocks } from "./components/formOptionalBlocks.component";
new FormOptionalBlocks();

import { NavigationComponent } from './components/navigation.component';
new NavigationComponent();

import { ToTopComponent } from './components/toTop.component';
new ToTopComponent();

import { CarouselComponent } from './components/carousel.component';
new CarouselComponent();

import { LightboxComponent } from './components/lightbox.component';
new LightboxComponent();

import './components/googleMaps';

///SCSS
import '../scss/main.scss';
